import { setupClass } from './Base.js'

/**
 * Helper class to contain a list of project errors
 */
export class ProjectErrors {
  init() {
    this.errors = [];

    this.serFields = [
      'errors',
    ]
  }

  getErrors() {
    return this.errors;
  }

  setErrors(errors) {
    this.errors = errors;
  }

  isEmpty() {
    return this.errors.length === 0;
  }

  checkPageHasErrors(pagePath) {
    // Normalize the pagePath to ensure it starts with a slash
    const normalizedPagePath = pagePath.startsWith('/') ? pagePath : '/' + pagePath;
    
    for (const errObj of this.errors) {
      // Normalize the error page path if it exists
      if (errObj.page?.path) {
        const normalizedErrPath = errObj.page.path.startsWith('/') ? errObj.page.path : '/' + errObj.page.path;
        if (normalizedErrPath.startsWith(normalizedPagePath)) {
          return true;
        }
      }
      
      // Also check the child paths, for more specific matchings
      for (const child of errObj.childDetails) {
        // Normalize the child path
        const normalizedChildPath = child.path.startsWith('/') ? child.path : '/' + child.path;
        if (normalizedChildPath.startsWith(normalizedPagePath)) {
          return true;
        }
      }
    }
    return false;
  }
}
setupClass(ProjectErrors)
